import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 22 22"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M11 15.714A4.714 4.714 0 1 1 15.714 11 4.715 4.715 0 0 1 11 15.714zm9.429-7.071h-.714A8.958 8.958 0 0 0 18.83 6.5l.5-.5a1.575 1.575 0 0 0 0-2.222l-1.108-1.111a1.574 1.574 0 0 0-2.222 0l-.5.5a9.022 9.022 0 0 0-2.139-.884v-.712A1.576 1.576 0 0 0 11.786 0h-1.572a1.576 1.576 0 0 0-1.571 1.571v.714A9.023 9.023 0 0 0 6.5 3.17l-.5-.5a1.574 1.574 0 0 0-2.222 0L2.667 3.778a1.575 1.575 0 0 0 0 2.222l.5.5a8.96 8.96 0 0 0-.885 2.14h-.711A1.576 1.576 0 0 0 0 10.214v1.571a1.576 1.576 0 0 0 1.571 1.571h.714A8.959 8.959 0 0 0 3.17 15.5l-.5.5a1.575 1.575 0 0 0 0 2.222l1.111 1.111a1.574 1.574 0 0 0 2.222 0l.5-.5a8.992 8.992 0 0 0 2.14.885v.714A1.576 1.576 0 0 0 10.214 22h1.571a1.576 1.576 0 0 0 1.571-1.571v-.714a8.992 8.992 0 0 0 2.144-.885l.5.5a1.574 1.574 0 0 0 2.222 0l1.111-1.111a1.575 1.575 0 0 0 0-2.222l-.5-.5a8.957 8.957 0 0 0 .885-2.139h.714A1.576 1.576 0 0 0 22 11.786v-1.572a1.576 1.576 0 0 0-1.571-1.571z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };